;(function() {
	let changed = false
	window.onresize = displayWindowSize
	window.onload = displayWindowSize

	function displayWindowSize() {
		let width = window.visualViewport.width
		// your size calculation code here
		let $img = $('.full-width-image')

		if (width < 640) {
			changed = true
			let src = $img.attr('data-imgMobile')
			$img.attr('src', src)
		}
		if (width > 640) {
			changed = true
			let src = $img.attr('data-img')
			$img.attr('src', src)
		}
	}
})()
